export default "__VITE_ASSET__BZEFQZNU__"